export const supplierApi = {
  list: {
      method: 'post',
      api: 'admin/supplier/list'
  },
  alllist: {
    method: 'post',
    api: 'admin/supplier/alllist'
},
  save: {
    method: 'post',
    api: 'admin/supplier/save'
  },
  get: {
    method: 'post',
    api: 'admin/supplier/get'
  },
  del: {
    method: 'post',
    api: 'admin/supplier/del'
  },
  getWlnList: {
    method: 'post',
    api: 'admin/supplier/getWlnList'
  },
  getWlnShopList: {
    method: 'post',
    api: 'admin/supplier/getWlnShopList'
  },
  getCompanyList: {
    method: 'post',
    api: 'admin/supplier/getWlnCompanyList'
  },
}